<template>
  <Partner />
</template>

<script>
import Partner from '@/components/content/partners/EditSelectedPartner.vue'

export default {
  name: 'ContentPartnerHistory',
  components: { Partner }
}
</script>

<style scoped>

</style>
